var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseWhite = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 18,
  height: 18,
  viewBox: "0 0 16 16",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "close-white_svg__a",
  d: "M11.612 9.741a1.322 1.322 0 1 1-1.87 1.871L6 7.871 2.26 11.612a1.322 1.322 0 1 1-1.871-1.87L4.129 6 .388 2.258a1.322 1.322 0 1 1 1.87-1.87L6 4.129 9.742.388a1.322 1.322 0 1 1 1.87 1.87L7.871 6z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "close-white_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#close-white_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#close-white_svg__a",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#close-white_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2-2h16v16H-2z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseWhite);
export default ForwardRef;